var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStageClipLogoBlackText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 62,
    viewBox: "0 0 127 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8b37fhy2ga",
    d: "M27.504.157C12.314.157 0 12.482 0 27.687 0 42.89 12.314 55.214 27.504 55.214c2.277 0 4.49-.277 6.606-.799 5.532 6.864 18.137 7.598 18.137 7.598s-8.67-6.007-7.447-12.922c6.227-5.047 10.209-12.76 10.209-21.406C55.009 12.482 42.694.157 27.504.157z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wek94mkbld",
    d: "M.086 3.56c0 1.932 11.038 3.499 24.654 3.499 13.615 0 24.653-1.567 24.653-3.5 0-1.934-11.038-3.5-24.653-3.5C11.124.058.086 1.624.086 3.558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1sxtu8g2g",
    d: "M0 72L126.175 72 126.175 0.158 0 0.158z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h3oememr3e",
    cx: "50%",
    cy: "50%",
    r: "352.14%",
    fx: "50%",
    fy: "50%",
    gradientTransform: "matrix(.14198 0 0 .1413 .429 .43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jayu05mjib",
    x1: "69.642%",
    x2: "21.469%",
    y1: "4.172%",
    y2: "146.667%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#18a957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#068040"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 -32) translate(113 32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s64go36lzc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8b37fhy2ga"
  })), /*#__PURE__*/React.createElement("path", {
    id: "gradientColors",
    fill: "url(#jayu05mjib)",
    d: "M27.504.157C12.314.157 0 12.482 0 27.687 0 42.89 12.314 55.214 27.504 55.214c2.277 0 4.49-.277 6.606-.799 5.532 6.864 18.137 7.598 18.137 7.598s-8.67-6.007-7.447-12.922c6.227-5.047 10.209-12.76 10.209-21.406C55.009 12.482 42.694.157 27.504.157z",
    mask: "url(#s64go36lzc)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 -32) translate(113 32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B5E8F",
    d: "M41.591 27.836c0 7.704-6.248 13.95-13.955 13.95s-13.954-6.246-13.954-13.95c0-7.704 6.247-13.95 13.954-13.95 7.707 0 13.955 6.246 13.955 13.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M34.622 27.479c.223.129.223.45 0 .58l-10.569 6.1c-.223.128-.502-.033-.502-.29v-12.2c0-.257.279-.418.502-.29l10.57 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1e2b",
    d: "M78.571 26.482c-2.392 0-4.012-.951-4.012-4.139v-6.53h-1.646v-3.341h1.646V8.95h3.91v3.522h3.24v3.341h-3.24V21.7c0 .9.385 1.337 1.26 1.337.72 0 1.362-.18 1.928-.488v3.136c-.823.489-1.774.797-3.086.797M91.456 20.698c-.669-.309-1.543-.514-2.495-.514-1.672 0-2.7.668-2.7 1.902v.051c0 1.055.874 1.672 2.135 1.672 1.825 0 3.06-1.003 3.06-2.417v-.694zm-.077 5.553V24.76c-.952 1.053-2.264 1.747-4.167 1.747-2.597 0-4.732-1.49-4.732-4.215v-.052c0-3.008 2.29-4.396 5.555-4.396 1.39 0 2.392.231 3.37.566v-.231c0-1.62-1.004-2.52-2.958-2.52-1.492 0-2.546.283-3.806.746l-.977-2.982c1.517-.669 3.008-1.106 5.349-1.106 4.269 0 6.146 2.211 6.146 5.939v7.995h-3.78zM107.247 18.641c0-1.876-1.466-3.187-3.37-3.187-1.902 0-3.343 1.31-3.343 3.187v.051c0 1.903 1.44 3.188 3.344 3.188 1.903 0 3.369-1.31 3.369-3.188v-.05zm-3.832 11.774c-2.237 0-4.347-.514-6.095-1.44l1.337-2.93c1.415.797 2.83 1.26 4.655 1.26 2.675 0 3.935-1.286 3.935-3.754v-.668c-1.157 1.388-2.418 2.237-4.5 2.237-3.215 0-6.121-2.34-6.121-6.428v-.05c0-4.114 2.957-6.427 6.12-6.427 2.135 0 3.395.9 4.45 2.056v-1.8h3.908V23.14c0 5.193-2.571 7.275-7.69 7.275zM119.463 15.35c-1.62 0-2.675 1.158-2.983 2.931h5.889c-.232-1.748-1.26-2.93-2.906-2.93m6.66 5.373h-9.592c.386 1.773 1.62 2.698 3.37 2.698 1.31 0 2.262-.41 3.342-1.413l2.238 1.98c-1.286 1.593-3.138 2.57-5.632 2.57-4.14 0-7.201-2.905-7.201-7.121v-.051c0-3.933 2.803-7.173 6.815-7.173 4.603 0 6.712 3.574 6.712 7.481v.052c0 .385-.026.617-.052.977"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "gt39zima0h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1sxtu8g2g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1e2b",
    d: "M76.742 47.238L80.651 47.238 80.651 28.472 76.742 28.472zM83.223 47.238h3.909v-13.78h-3.91v13.78zm-.103-15.296h4.114v-3.47H83.12v3.47zM100.093 40.322c0-2.288-1.543-3.804-3.369-3.804-1.825 0-3.343 1.516-3.343 3.804v.052c0 2.288 1.518 3.804 3.343 3.804 1.826 0 3.37-1.49 3.37-3.804v-.052zm-2.366 7.172c-2.083 0-3.368-.95-4.294-2.056v5.913h-3.91V33.459h3.91v1.979c.951-1.286 2.263-2.236 4.294-2.236 3.215 0 6.275 2.519 6.275 7.12v.052c0 4.601-3.008 7.12-6.275 7.12zM64.731 18.975c3.01.772 3.627 1.286 3.627 2.288v.052c0 1.054-.978 1.696-2.598 1.696-1.183 0-2.245-.287-3.244-.78.207 1.293.343 2.608.405 3.944.908.22 1.836.332 2.762.332 3.883 0 6.61-2.004 6.61-5.578v-.051c0-3.136-2.058-4.448-5.71-5.399-3.112-.796-3.883-1.182-3.883-2.365v-.051c0-.874.797-1.568 2.314-1.568s3.086.668 4.68 1.773l2.058-2.982c-1.826-1.465-4.063-2.288-6.686-2.288-2.97 0-5.25 1.41-6.019 3.67 1.023 1.98 1.862 4.07 2.498 6.246.89.425 1.963.749 3.186 1.061M72.575 41.788c-1.414 1.285-2.674 2.108-4.732 2.108-3.086 0-5.22-2.571-5.22-5.656v-.052c0-3.084 2.186-5.603 5.22-5.603 1.8 0 3.215.77 4.604 2.03l2.52-2.905c-1.672-1.645-3.703-2.776-7.098-2.776-1.889 0-3.582.49-4.993 1.337-.305 4.47-1.441 8.71-3.256 12.57 1.536 2.823 4.5 4.705 8.095 4.705 3.471 0 5.529-1.234 7.38-3.214l-2.52-2.544z",
    mask: "url(#gt39zima0h)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageClipLogoBlackText);
export default __webpack_public_path__ + "static/media/stage-clip-logo-black-text.09d14a23066aaca99c65930c56c35655.svg";
export { ForwardRef as ReactComponent };